<script lang="ts">
  import { Card, CardBody, CardHeader, Col } from "sveltestrap";
  import data from "../../../../Data/ComponentData/DashboardData/EcommerceData/OurTarget.json";
</script>

<Col xl="6" class="box-col-6">
  <Card class="target-sec">
    <CardHeader >
      <ul class="target-list">
        {#each data.ourtargetdata as targetItem}
          <li class={targetItem.class}>
            <h6>{targetItem.title}</h6>
            <p>{targetItem.discription}</p>
            <span>{targetItem.target}</span>
          </li>
        {/each}
      </ul>
    </CardHeader>
    <CardBody class="p-0">
      <div class="traget-img-sec" />
      <div class="animat-block">
        <i class="fa fa-times close1" />
        <i class="fa fa-times close2" />
        <i class="fa fa-times close3" />
        <div class="circle1" />
        <div class="circle2" />
        <div class="circle3" />
      </div>
    </CardBody>
  </Card>
</Col>
